export const state = {
  Branches: [],
};
export const mutations = {
  SAVE_BRANCHES(state, branch) {
    state.Branches = branch;
  },
  CLEAR_BRANCHES(state) {
    state.Branches = [];
  },
};
export const actions = {
  loadBaraches({ state, dispatch, commit }, mode = false) {
    if (state.Branches.length && !mode) return;
    dispatch("GET_ONLY", "/branches")
      .then(branches => {
        commit("SAVE_BRANCHES", branches.data);
      })
      .catch(err => {
        console.log(err);
      });
  },
};

export const getters = {
  GetBranches(state) {
    return state.Branches;
  },
};
